<div class="object-view-field-checkbox">
  <mat-checkbox *ngIf="checkboxField"
                class="object-view-field-checkbox__checkbox"
                [(ngModel)]="checkboxModel"
                (ngModelChange)="checkboxValueChanged()"></mat-checkbox>
  <div class="object-view-field-checkbox__checkbox-content"
        [ngClass]="{'has-checkbox': checkboxField}"><ng-content></ng-content></div>
</div>

